import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import ModernScheduleInterview from './ModernScheduleInterview';
import ct from 'countries-and-timezones';
import { ChevronDown } from 'lucide-react';
import '../../css/platformCalendar.css';
import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '../../hooks/useTheme';

function ScheduleInterviewDialog({
  handleScheduleInterviewForCandidates=()=>{},
  isSchedulePopupOpen=true,
  toggleSchedulePopup=()=>{},
  setDateRange=()=>{},
  dateRange=[null,null],
  isReschedule=false,
  existingStartDate,
  existingEndDate
}) {

  const {theme} = useTheme();
  return (
    <Dialog
        open={isSchedulePopupOpen}
        onClose={() => toggleSchedulePopup(false)}
        PaperProps={{
          sx: {
            background: `${theme === 'dark' ? 'linear-gradient(to bottom right, rgba(34,52,97,0.25), rgba(11,10,31,0.05))' : ''}`,
            backdropFilter: 'blur(50px)',
            WebkitBackdropFilter: 'blur(50px)',
            borderRadius: '12px',
            padding: '0px',
            maxWidth: '600px',
            width: '100%',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            transition: 'none !important',
          },
        }}
        TransitionProps={{
          timeout: 0,
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          {isSchedulePopupOpen && (
            <ModernScheduleInterview
              onClose={() => toggleSchedulePopup(false)}
              isReschedule={isReschedule}
              existingStartDate={existingStartDate}
              existingEndDate={existingEndDate}
              onConfirm={(data) => {
                // Extract timezone (always set) and timeslot (null if not using specific slots)
                const scheduledTimezone = data.timezone;
                const scheduledTimeslot = data.timeslot || null;
                const calculatedRange = [data.startDate, data.endDate];

                setDateRange(calculatedRange);
                
                // Pass scheduleOptions as second arg so the parent can store timezone/timeslot in the DB
                handleScheduleInterviewForCandidates(calculatedRange, {
                  timezone: scheduledTimezone,
                  timeslot: scheduledTimeslot,
                });
                toggleSchedulePopup(false);
              }}
            />
          )}
        </DialogContent>
      </Dialog>
  )
}

export default ScheduleInterviewDialog
